var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgEmail = function SvgEmail(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.6C20 6.72 19.28 6 18.4 6H5.6C4.72 6 4 6.72 4 7.6V17.2C4 18.08 4.72 18.8 5.6 18.8H18.4C19.28 18.8 20 18.08 20 17.2V7.6ZM18.4 7.6L12 11.6L5.6 7.6H18.4ZM18.4 17.2H5.6V9.2L12 13.2L18.4 9.2V17.2Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNEMwIDEuNzkwODYgMS43OTA4NiAwIDQgMEgyMEMyMi4yMDkxIDAgMjQgMS43OTA4NiAyNCA0VjIwQzI0IDIyLjIwOTEgMjIuMjA5MSAyNCAyMCAyNEg0QzEuNzkwODYgMjQgMCAyMi4yMDkxIDAgMjBWNFoiIGZpbGw9IiMzMzMzMzMiLz4KPHBhdGggZD0iTTIwIDcuNkMyMCA2LjcyIDE5LjI4IDYgMTguNCA2SDUuNkM0LjcyIDYgNCA2LjcyIDQgNy42VjE3LjJDNCAxOC4wOCA0LjcyIDE4LjggNS42IDE4LjhIMTguNEMxOS4yOCAxOC44IDIwIDE4LjA4IDIwIDE3LjJWNy42Wk0xOC40IDcuNkwxMiAxMS42TDUuNiA3LjZIMTguNFpNMTguNCAxNy4ySDUuNlY5LjJMMTIgMTMuMkwxOC40IDkuMlYxNy4yWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";